<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/escrDS/tc-custom/9781467445436.jpg?1728851918185" alt="This image is the cover for the book Wisdom's Feast"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Wisdom's Feast
      </h1>
      <p class="bookDescription body article font2">
        <p>Woman Wisdom in Proverbs 9 invites any who want to learn her ways to come and eat at her table—an image for the rich and satisfying teaching that she offers. In this book Barbara Reid invites readers to this feast, drawing on women's wisdom to offer fresh new interpretations of biblical texts in a way that promotes equal dignity and value for women and men alike.<br/><br/> Reid begins by presenting feminist methods of biblical interpretation and explaining why they are important, giving attention not only to gender perspectives but also to race, class, and culture as determinative factors in how one understands the biblical text. She then presents fresh, readable feminist interpretations of selected Old and New Testament texts. Each chapter concludes with discussion questions for group or personal use.<br/><br/> Making feminist interpretation of Scripture understandable, compelling, and usable, <i>Wisdom's Feast</i>will be valuable to any readers hungry to learn from the rich insights of feminist biblical scholars.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Barbara E. Reid
      </h2>
      
      <p class="authorDescription body article">Barbara E. Reid is vice president, academic dean, and professor of New Testament studies at Catholic Theological Union, Chicago. Her previous books include <I>Taking Up the Cross: New Testament</I><I>Interpretation through Latina and Feminist Eyes.</I><BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?71a1a01e